function parseFilter(filter, variableName) {
    return filter
      .replaceAll(variableName, "variable")
      .replace("[", "")
      .replace("]", "")
      .replace(/'/g, "")
      .replace("AND", "&&")
      .replace(">=", ">=")
      .replace("<=", "<=")
      .replace(">", ">")
      .replace("<", "<");
  }
  
  export const getFillValue = ( legendData, variableName, variableValue ) => {

    if (legendData !== '' && variableValue !== '' && variableName !== '' && variableValue > 0) {
    for (const rule of legendData) {
      if (rule.ElseFilter) continue
      if (rule.filter.includes(variableName)) {
      const filter = parseFilter(rule.filter, variableName);
      const condition = new Function('variable', `return ${filter};`);
  
      // Evaluar la condición
      if (condition(variableValue)) {
        const maxFilter = rule.filter.match(/<=\s*'([^']+)'/)[1]; // Extrae el límite máximo del filtro
        return {
          fill: rule.symbolizers[0].Polygon.fill,
          maxLimit: parseFloat(maxFilter)
        };
      }
    }
  }
}

if (variableValue < 0) {
  return 'Sin información'
}
  
    return ''; // Si no se encuentra ninguna coincidencia
  }